var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-cover",class:{
    overlay: _vm.transparent,
    noCover: _vm.transparentFull,
    inverted: _vm.invert,
    fixed: _vm.fixed,
    unobtrusive: _vm.unobtrusive
  },style:(_vm.zIndex && ("z-index: " + _vm.zIndex))},[_c('div',{staticClass:"content",class:{ center: _vm.center, unobtrusive: _vm.unobtrusive }},[_c('v-progress-linear',{attrs:{"color":_vm.invert ? '#23F6A4' : 'white',"indeterminate":"","reverse":"","size":_vm.small ? 40 : _vm.loaderSize}}),(_vm.status)?_c('p',{staticClass:"status-message",domProps:{"innerHTML":_vm._s(_vm.status)}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }